import { ApiConfig } from './api';
import { fetchWrapper, objectToSearchParams } from './utils/http-utils';
import { Organization, OrganizationCosts, OrganizationFeaturesDraft } from '../types/organization';
import { OrganizationFeatures } from '../types/organization';
import { Pagination } from '../types/widgets/common';

export const getOrganizations = (config: ApiConfig) => (): Promise<{ organizations: Organization[] }> =>
  fetchWrapper<{ organizations: Organization[] }>(`${config.endpoint}admin/organizations`, { method: 'GET' }, config);

export const getOrganizationFeatures =
  (config: ApiConfig) =>
  (id: number): Promise<{ data: OrganizationFeatures; pagination: Pagination }> =>
    fetchWrapper<{ data: OrganizationFeatures; pagination: Pagination }>(
      `${config.endpoint}admin/organizations/${id}/features`,
      { method: 'GET' },
      config
    );

export const updateOrganizationFeatures =
  (config: ApiConfig) =>
  (id: number, data: OrganizationFeaturesDraft): Promise<{ data: OrganizationFeatures }> =>
    fetchWrapper<{ data: OrganizationFeatures }>(
      `${config.endpoint}admin/organizations/${id}/features`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      },
      config
    );

export const getCosts =
  (config: ApiConfig) =>
  (organization_id: number, year: string, month: string): Promise<OrganizationCosts> => {
    const searchParams = objectToSearchParams({
      organization_id,
      year,
      month,
    });

    return fetchWrapper<OrganizationCosts>(`${config.endpoint}job-report?${searchParams}`, { method: 'GET' }, config);
  };

export const updateOrganizationStatus =
  (config: ApiConfig) =>
  (id: number, is_active: boolean): Promise<Organization> =>
    fetchWrapper<Organization>(
      `${config.endpoint}admin/organizations/${id}/active`,
      {
        method: 'PUT',
        body: JSON.stringify({ is_active }),
      },
      config
    );
